export default __webpack_public_path__ + "static/media/mobile-logo.fa95dd24.svg";